export default __webpack_public_path__ + "static/media/restart.e98da380.svg";